import { render, staticRenderFns } from "./Packaging.vue?vue&type=template&id=3500de01&scoped=true&"
import script from "./Packaging.vue?vue&type=script&setup=true&lang=js&"
export * from "./Packaging.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Packaging.vue?vue&type=style&index=0&id=3500de01&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3500de01",
  null
  
)

export default component.exports